import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import Fingerprint2 from 'fingerprintjs2';
import authProvider from '../../core/AuthenticationProvider';
import { saveLayout } from '../main-layout/sidebar/reducer';
import Desktop from './Desktop';

class Home extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isRender: false,
    };

    authProvider
      .getUser()
      .then(user => {
        // if (!user || user.expired) {
        //   //get browser fingerprint
        //   Fingerprint2.get(components => {
        //     var values = components.map(function(component) {
        //       return component.value;
        //     });
        //     var fp = Fingerprint2.x64hash128(values.join(''), 31);
        //
        //     authProvider.signin({
        //       extraQueryParams: {
        //         type: window.opener ? 'popup' : 'redirect',
        //         fp: fp,
        //       },
        //     });
        //   });
        //
        //   return;
        // }
        this.setState({
          isRender: true,
        });
        this.user = user;
        if (user) {
          const timeout = user.expires_at * 1000 - new Date().getTime();
          this.timeoutSave = setTimeout(() => {
            props.saveLayout();
          }, timeout - 2000);
        }
      })
      .catch(e => {
        console.log(e);
        // window.location = '/';
      });
  }

  render() {
    const { isRender } = this.state;
    if (!isRender) {
      return null;
    }

    return <Desktop />;
  }
}

const mapDispatchToProps = {
  saveLayout,
};

export default connect(
  null,
  mapDispatchToProps,
)(Home);
